// Central utility for defining when an entry should not be output to the page.
export default function isNoItem(str) {
    if (String(str).toLowerCase() === "[[noitem]]") return true;
}
